import I18n from 'I18n';
import UIStepperButton from './UIStepperButton';
import omit from '../utils/underscore/omit';
import { jsx as _jsx } from "react/jsx-runtime";
export default function UIPreviousButton(props) {
  return /*#__PURE__*/_jsx(UIStepperButton, Object.assign({
    "aria-label": I18n.text('salesUI.UIPreviousButton.label'),
    iconName: "previous"
  }, props));
}
const EXCLUDED_STEPPER_BUTTON_PROP_NAMES = ['iconName', 'aria-label'];
UIPreviousButton.propTypes = Object.assign({}, omit(UIStepperButton.propTypes, EXCLUDED_STEPPER_BUTTON_PROP_NAMES));
UIPreviousButton.defaultProps = Object.assign({}, omit(UIStepperButton.defaultProps, EXCLUDED_STEPPER_BUTTON_PROP_NAMES));
UIPreviousButton.displayName = 'UIPreviousButton';